import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AddressLookupService } from '../address-lookup.service';
import { FormGroup } from '@angular/forms';
import { QuestionBase } from '../../domain/question.base';
import { QuestionComponent } from '../question.component';
import { ScrollService } from '../scroll.service';

@Component({
  selector: `crds-question-postcode`,
  template: `
    <div *ngIf="show" [formGroup]="form" class="input-group mb-3">
      <label *ngIf="question.label" class="form-label" [attr.for]="question.key"
        >{{ question.label }}
        <span *ngIf="question.required"> *</span>
        <crds-form-error *ngIf="isInvalid" [question]="question" [message]="question.errorMessage"></crds-form-error>
      </label>
      <input
        [formControlName]="question.key"
        [id]="question.key"
        [type]="question.controlType"
        class="form-control"
        style="text-transform: uppercase"
        (change)="onChange()"
        [placeholder]="question.placeholder || ''"
        #postCodeInput
      />
      <div class="input-group-append">
        <button
          class="btn btn-primary"
          [disabled]="form.get(question.key).invalid"
          (click)="lookupByPostCode(form.get(question.targetArg).value)"
          type="button"
        >
          {{ question.targetLabel }}
        </button>
      </div>

      <!-- QUESTION HINT -->
      <crds-question-hint [question]="question"></crds-question-hint>
    </div>
  `
})
export class PostcodeQuestionComponent extends QuestionComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() question: QuestionBase<string>;
  @ViewChild('postCodeInput') input;
  type: string;

  constructor(private addressLookupService: AddressLookupService, private scrollService: ScrollService) {
    super();
  }

  ngOnInit() {
    this.scrollService.scrollObservable.subscribe(documentId => {
      if (documentId === this.question.key) {
        this.input.nativeElement.scrollIntoView();
      }
    });
  }

  onChange() {
    const field = this.form.get(this.question.key);
    if (field.value) {
      field.setValue(field.value.toUpperCase());
    }
  }

  lookupByPostCode(postCode: string): void {
    this.addressLookupService.lookupByPostCode(postCode);
  }

  get isInvalid() {
    return this.form.get(this.question.key).touched && this.form.get(this.question.key).invalid;
  }

  get show() {
    const showIfQuestionPopulated = this.question.showIf ? this.showIf : true;
    return (
      (this.question.showIfPopulated !== true || this.value) && showIfQuestionPopulated && this.question.show !== false
    );
  }
}
